export const EXTERNAL_VALUATION_SPREADSHEET_EXTERNAL_VALUATION_TITLE = 'External Valuation';
export const EXTERNAL_VALUATION_SPREADSHEET_ENTERPRISE_VALUE_TITLE = 'Enterprise Value';
export const EXTERNAL_VALUATION_SPREADSHEET_EQUITY_VALUE_TITLE = 'Equity Value';
